import React, { useState, useEffect } from "react";
import AreaMenu from "./LayoutComponents/AreaMenu.js";
import AreaGame from "./LayoutComponents/AreaGame.js";
import { FrameVanishDiv, FrameDiv } from "./LayoutComponents/SmallComponents";

import { AnimatePresence } from "framer-motion"
import "semantic-ui-css/semantic.min.css";
import "./css/App.css";

function App() {
  const [area, setArea] = useState("");
  const [renderGame, setRenderGame] = useState(true);
  const [startGame, setStartGame] = useState(false);
  
  const [iconText, setIconText] = useState(null);
  const [generalText, setGeneralText] = useState(null);

  useEffect(() => {

    fetch('./data/data.json', { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        setIconText(data.iconText);
        setGeneralText(data.generalText);
        setArea("menu");
      });


    const resizeListener = () => {
      setRenderGame(false);
      setTimeout(() => { setRenderGame(true); }, 100);
    };
    window.addEventListener('resize', resizeListener);
    return () => { window.removeEventListener('resize', resizeListener); }
  }, [])


  function QuickStart(inquiries, characters) {
    setArea("game");
    setStartGame(true);
  }



  return (
    <FrameDiv style={{ background: "black" }}>

      <AnimatePresence>
        {area === "game" && (
          <FrameVanishDiv key="game" style={{ background: "black" }}>
            <AreaGame
              setArea={setArea}
              startGame={startGame}
              renderGame={renderGame}
              iconText={iconText}
              generalText={generalText}
            />
          </FrameVanishDiv>
        )}
        {renderGame && (
          <>
            {area === "menu" && (
              <AreaMenu
                setArea={setArea}
              />
            )}
          </>
        )}
      </AnimatePresence>
    </FrameDiv>
  );
}

export default App;
